import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--moodboard_image',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_link_external: null,
      field_link_module: null,
      field_link_text: 'Lorem ipsum',
      field_search_text: null,
      field_title: { value: '', format: 'rich_text' },
    },
    relationships: {
      field_image: {},
      field_tags: {
        data: [],
      },
    },
    links: {},
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
